"use client";

import { Youtube } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YouTubeCreatorAwards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="youtubecreatorawards" className="bg-background py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col items-center text-center mb-16 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="outline" className="mb-6 font-mono py-1.5 px-4 border-foreground/20">
            <Youtube className="w-4 h-4 mr-2 text-destructive" />
            Milestone Achieved
          </Badge>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default tracking-tight mb-6 text-foreground">
            YouTube Creator Award
          </h2>
          <p className="text-muted-foreground max-w-2xl font-sans text-lg md:text-xl">
            Recognizing the global impact and reach of David Scott Linthicum's insights in AI and Cloud Computing.
          </p>
        </div>

        <div className={`max-w-5xl mx-auto transition-all duration-1000 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative rounded-3xl overflow-hidden bg-foreground shadow-2xl p-1">
            {}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/40 via-transparent to-secondary/20 opacity-60"></div>

            <div className="relative bg-foreground/90 backdrop-blur-2xl rounded-2xl p-8 md:p-16 lg:p-20 flex flex-col items-center border border-background/10">
              <div className="w-full max-w-2xl mx-auto mb-12 relative">
                {}
                <div className="absolute inset-0 bg-background/5 blur-3xl rounded-lg"></div>
                <AspectRatio ratio={16 / 9}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/bonkers_image_show_me_an (19).jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/bonkers_image_show_me_an (19).jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/bonkers_image_show_me_an (19).jpg-wvc-sizes" alt="YouTube 100K Subscriber Silver Play Button Award" className="object-contain w-full h-full relative z-10 drop-shadow-2xl" loading="lazy" />
                </AspectRatio>
              </div>

              <Separator className="bg-background/20 w-24 mb-10" />

              <p className="text-background/80 font-mono text-base md:text-lg lg:text-xl text-center max-w-3xl leading-relaxed tracking-wide">
                "Presented to David Scott Linthicum for passing 100,000 subscribers. A testament to the growing community of tech professionals dedicated to mastering the future of AI and Cloud Computing."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}